<template>
    <nav
        role="navigation"
        class="ml-2 border-l-2 border-white/10 pb-1 pl-2 pr-1"
    >
        <ul class="flex flex-col">
            <li :class="linkWrapClass()">
                <NavigationLink
                    label="Today's Games"
                    :link="route('bbnow', { sport: 'mbb' })"
                    icon="wastebasket.png"
                    component="BBNow"
                    :tabindex="0"
                />
            </li>
            <li :class="linkWrapClass()">
                <NavigationLink
                    label="Conf/Team"
                    :link="
                        route('mbbschedules', {
                            conference:
                                selectedConference?.slug ?? 'america-east',
                            team:
                                selectedTeam?.short_name?.toLowerCase() ??
                                'all',
                        })
                    "
                    :icon="selectedTeam?.logo ?? 'notebook.png'"
                    component="MBB"
                    :tabindex="0"
                />
            </li>
            <li :class="linkWrapClass()">
                <NavigationLink
                    label="Standings"
                    :link="
                        route('mbbstandings', {
                            conference:
                                selectedConference?.slug ?? 'america-east',
                        })
                    "
                    icon="trophy.png"
                    component="MBBStandings"
                    :tabindex="0"
                />
            </li>
            <li :class="linkWrapClass()">
                <NavigationLink
                    label="Rankings"
                    :link="route('mbbtop25')"
                    icon="clipboard.png"
                    component="MBBTop25"
                    :tabindex="0"
                />
            </li>
            <li
                v-if="
                    ['MBBNow', 'MBBPlayer', 'MBBTop25', 'MBBStandings'].indexOf(
                        $page.component,
                    ) < 0
                "
                class="mt-1 w-full px-1"
            >
                <label for="teamSelector" class="text-xxs uppercase"
                    >Conf/Team</label
                ><br />
                <select
                    id="teamSelector"
                    class="w-full bg-slate-300 p-1 text-xs text-slate-900"
                    v-model="selectedTeam"
                    @change="setTeam"
                >
                    <option v-for="t in teamsAndConfs" :value="t.value">
                        {{ t.name }}
                        {{ t.school }}<span v-if="t.rank">({{ t.rank }})</span>
                    </option>
                </select>
            </li>
        </ul>
    </nav>
</template>

<script>
import BasketballNavigationLink from './BasketballNavigationLink.vue';
import { Head } from '@inertiajs/vue3';
import { mapActions, mapWritableState } from 'pinia';
import { useGeneralStore } from '@/utils/useGeneralStore';
import { basketballStore } from '@/utils/basketballStore';
import { router } from '@inertiajs/vue3';
import * as DataService from '@/DataService';

export default {
    name: 'BasketballNavigationLinks',
    props: ['conferences', 'conference', 'team', 'player'],
    components: { Head, NavigationLink: BasketballNavigationLink },

    computed: {
        ...mapWritableState(useGeneralStore, ['showMobile']),
        ...mapWritableState(basketballStore, [
            'selectedConference',
            'selectedSeason',
            'selectedTeam',
            'selectedPlayer',
            'teamsAndConfs',
        ]),
        conferencesFiltered() {
            return this.conferences;
        },
    },
    data() {
        return {
            selectedConferenceSlug: null,
        };
    },
    created() {
        this.getTeamsAndConfs();
    },
    mounted() {
        if (this.conference) {
            this.selectedConference = this.conference;
            this.setConference();
        }
        if (this.team) {
            this.selectedTeam = this.team;
        }
        // if(this.conference) {
        //     this.selectedConference=this.conference;
        //     this.setConference();
        // }else if(localStorage.getItem('selectedConference')){
        //     this.selectedConference=localStorage.getItem('selectedConference') ? JSON.parse(localStorage.getItem('selectedConference')) : null;
        // }

        if (this.player) {
            this.selectedPlayer = this.player;
        } else if (localStorage.getItem('selectedPlayer')) {
            this.selectedPlayer = JSON.parse(
                localStorage.getItem('selectedPlayer'),
            );
        }
    },
    methods: {
        ...mapActions(useGeneralStore, ['setItem', 'getItem']),
        linkWrapClass() {
            return 'flex flex-wrap group mb-1';
        },
        getTeamsAndConfs() {
            DataService.client.get('/api/teams-and-confs').then((d) => {
                this.teamsAndConfs = d.data;
            });
        },
        getTitle(c) {
            let link = this.links.find((l) => l.component === c);
            return link?.pageTitle ? link?.pageTitle : '';
        },
        setConference() {
            const conf = this.conferences?.find(
                (c) => c.id == this.selectedConference.id,
            );
            localStorage.setItem('selectedConference', JSON.stringify(conf));
            const currentParams = route().params;
            let params = {};
            if (currentParams.conference) {
                params = {
                    conference: this.selectedConference?.slug,
                    team: 'all',
                };
            }
            router.visit(route(route().current(), params));
        },
        setTeam() {
            if (this.selectedTeam && typeof this.selectedTeam == 'object') {
                localStorage.setItem(
                    'selectedTeam',
                    JSON.stringify(this.selectedTeam?.team),
                );

                // const conf=this.conferences?.find(c => c.slug == this.selectedTeam.conf);
                // localStorage.setItem('selectedConference', JSON.stringify(conf));
                router.visit(
                    route(route().current(), {
                        conference: this.selectedTeam?.conf,
                        team: this.selectedTeam?.team,
                    }),
                );
            }
            // let team=this.selectedTeam?.short_name.toLowerCase();
            // let urlparts=this.$page.url.split('/');
            // urlparts[3]=team;
            // router.visit(urlparts.join("/"));
        },
        getCurrentSeason() {
            return this.selectedSeason;
        },
    },
};
</script>
<style>
.hamburger svg {
    transition: all 0.25s cubic-bezier(0.19, 1, 0.22, 1);
}
</style>
